/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import LeaderboardListItem from './LeaderboardListItem';
export default class PodiumListItem extends LeaderboardListItem {
  items() {
    const {
      position
    } = this.attrs;
    const items = super.items();
    items.setPriority('avatar', 100);
    items.setPriority('username', 70);
    items.setPriority('count', 40);
    items.setPriority('position', 10);
    items.setContent('position', m("span", {
      className: `LeaderboardListItem-position ${this.getPositionClass(position)}`
    }, position));
    return items;
  }
  getPositionClass(position) {
    const {
      positionClass
    } = this.attrs;
    if (positionClass) {
      return positionClass;
    }
    switch (position) {
      case 1:
        return 'first';
      case 2:
        return 'second';
      case 3:
        return 'third';
    }
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/leaderboards/components/PodiumListItem', PodiumListItem);